<script lang="ts">
  import { orgMinus, orgPlus } from "@nrk/origo";
  import { imageSize, setImageSize } from "./imageSize";

  export let css: string = "";
  $: sliderScale = $imageSize * 5;


  function onSliderInput(event: Event) {
    setImageSize(Number((event.target as HTMLInputElement).value) / 5);
  }
</script>


<div class="image-size-adjuster {css}">
  {@html orgMinus}
  <input
    class="org-range"
    aria-label="størrelse på bildene"
    type="range"
    value={sliderScale}
    on:input={onSliderInput}
    min="1"
    max="10"
    step="0.5"
  />
  {@html orgPlus}
</div>


<style>
  .image-size-adjuster {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--org-color-shade-3);
    margin-right: var(--org-small);
  }


  @media (max-width: 768px) {
    .desktop-only { display: none; }
  }

  @media (min-width: 769px) {
    .mobile-only { display: none; }
  }
</style>